import PropTypes from 'prop-types'
import { Component } from 'react'

import ClearIcon from '../../img/clear-icon.svg'

class InputComponent extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isFocused: props.autoFocus ? true : false
    }
  }
  onBlur = e => {
    this.setState({ isFocused: false })
    this.props.onBlur && this.props.onBlur(e)
  }

  render() {
    return (
      <div
        className={`dashboard-custom-input  ${this.props.haserror ? 'has-error' : ''}`}
      >
        {this.props.hasclearinput ? (
          <img
            className="dashboard-custom-input__clear-icon"
            src={ClearIcon}
            onClick={this.props._onclearhandler}
            alt=""
          />
        ) : (
          ''
        )}
        {!this.props.floatinglabel ? (
          <label className="default-label" htmlFor={this.props.id}>
            {this.props.setlabel}
          </label>
        ) : (
          ''
        )}
        <input
          autoFocus={this.state.isFocused}
          className={!this.state.isFocused ? 'hide-placeholder' : ''}
          type={this.props.type ? this.props.type : 'text'}
          name={this.props.name}
          id={this.props.id}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onChange={this.props.onChange}
          value={this.props.value}
          required={this.props.isRequired === undefined ? true : false}
          placeholder={this.props.placeholder}
        />
        {this.props.floatinglabel ? (
          <label className="floating-label" htmlFor={this.props.id}>
            {this.props.setlabel}
          </label>
        ) : (
          ''
        )}
        {this.props.haserror ? (
          <p className="error-message">
            {this.props.errorMessage
              ? this.props.errorMessage
              : 'Something is wrong, please try again.'}
          </p>
        ) : (
          ''
        )}
      </div>
    )
  }
}

InputComponent.propTypes = {
  type: PropTypes.string,
  _onchangehandler: PropTypes.func,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
}

export default InputComponent
